/**
 * Utility functions for the application
 */

/**
 * Helper to get initials from a full name (e.g., "John Doe" -> "JD")
 * @param name The full name to get initials from
 * @returns Up to two uppercase initials
 */
export const getInitials = (name: string): string => {
    if (!name) return 'U';
    return name
        .trim()
        .split(/\s+/)
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
};
